'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _UICardSection = require('UIComponents/card/UICardSection');

var _UICardSection2 = _interopRequireDefault(_UICardSection);

var _UICardWrapper = require('UIComponents/card/UICardWrapper');

var _UICardWrapper2 = _interopRequireDefault(_UICardWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserContent = function (_Component) {
  _inherits(UserContent, _Component);

  function UserContent() {
    _classCallCheck(this, UserContent);

    return _possibleConstructorReturn(this, (UserContent.__proto__ || Object.getPrototypeOf(UserContent)).apply(this, arguments));
  }

  _createClass(UserContent, [{
    key: 'renderPlaceholder',
    value: function renderPlaceholder(text, key) {
      return _react2.default.createElement(
        _UICardWrapper2.default,
        { className: 'placeholder', key: key },
        _react2.default.createElement(
          _UICardSection2.default,
          null,
          text
        )
      );
    }
  }, {
    key: 'renderBadge',
    value: function renderBadge(badgeId) {
      var badge = this.props.inventory.academyBadges[badgeId];
      return _react2.default.createElement(
        'div',
        { className: 'badge', key: badge.name },
        _react2.default.createElement('img', { className: 'icon', src: badge.iconUrl }),
        _react2.default.createElement(
          'div',
          { className: 'title' },
          _react2.default.createElement(
            'span',
            null,
            badge.displayName
          )
        )
      );
    }
  }, {
    key: 'renderBadges',
    value: function renderBadges() {
      var _this2 = this;

      if (!this.props.user.academyBadges || this.props.user.academyBadges.length === 0) {
        return this.renderPlaceholder("Academy Badges (none yet)", 'badges');
      }
      return _react2.default.createElement(
        _UICardWrapper2.default,
        { className: 'badges', key: 'badges' },
        this.props.user.academyBadges.map(function (badgeId) {
          return _this2.renderBadge(badgeId);
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'user-content' },
        this.renderBadges(),
        this.renderPlaceholder('Coming Soon...', '2'),
        this.renderPlaceholder('Coming Soon...', '3')
      );
    }
  }]);

  return UserContent;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user,
      inventory = _ref.inventory;

  return { user: user, inventory: inventory };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(UserContent);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/UserContent.js
// module id = 574
// module chunks = 171